import DeployToWorld from './DeployToWorld.container'

export default DeployToWorld
